<div class="flex-row">
    <ng-container *ngrxLet="segObjectPropertyMaps$ as segObjectPropertyMaps">
        <ng-container *ngrxLet="selectedSegObjectPropertyMap$ as selectedSegObjectPropertyMap">
            <cds-select layout="vertical" controlWidth="stretch">
                <label>Intensity Maps</label>
                <select
                    name="segObjectPropertymap-panel"
                    class="free-selection-select"
                    [ngModel]="selectedSegObjectPropertyMap"
                    (ngModelChange)="setSegObjectPropertyMap($event)"
                >
                    <ng-container *ngFor="let segobjectmap of segObjectPropertyMaps">
                        <option [ngValue]="segobjectmap">{{ segobjectmap.name }}</option>
                    </ng-container>
                </select>
            </cds-select>
        </ng-container>
    </ng-container>
</div>
